import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { AccountLayout, PageShell } from "./accountUi";
import { FaRegEdit } from "react-icons/fa";
import ChangePasswordModal from "../../components/ChangePasswordModal";

/* ───────────────────────────────────────────────────────────────────────────
 * My Profile — reference kingexch111.com/myprofile.
 * "Account Details" dark-blue title, then rows: Name, Commission,
 * Exposure Limit, Password (with Edit).
 * ─────────────────────────────────────────────────────────────────────────── */

const titleBar = {
  background: "linear-gradient(180deg, #33475b 0%, #243746 100%)",
  color: "#fff",
  fontWeight: 700,
  fontSize: "16px",
  fontFamily: "Tahoma, Helvetica, sans-serif",
  padding: "6px 14px",
};
const labelRow = {
  background: "#fff",
  fontWeight: 700,
  fontSize: "14px",
  fontFamily: "Tahoma, Helvetica, sans-serif",
  color: "#212529",
  padding: "6px 12px 6px 17px",
  borderBottom: "1px solid #d7d7d7",
};
const valueRow = {
  background: "#fff",
  fontSize: "14px",
  fontFamily: "Tahoma, Helvetica, sans-serif",
  color: "#212529",
  padding: "6px 12px 6px 17px",
  borderBottom: "1px solid #d7d7d7",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const MyProfileNew = () => {
  const navigate = useNavigate();
  const [showChangePassword, setShowChangePassword] = useState(false);
  const { user, profileData } = useContext(AuthContext);
  const username = user?.user?.username || profileData?.username || "";
  const commission = profileData?.commission ?? 0;
  const exposureLimit = profileData?.exposureLimit ?? 0;

  return (
    <AccountLayout>
      <PageShell>
        <div style={{ padding: "26px 1px 0" }}>
          <div style={{ background: "#fff", border: "1px solid #d7d7d7", borderRadius: "6px", overflow: "hidden" }}>
            <div style={titleBar}>Account Details</div>

            <div style={labelRow}>Name</div>
            <div style={valueRow}>{username}</div>

            <div style={labelRow}>Commission</div>
            <div style={valueRow}>{commission}</div>

            <div style={labelRow}>Exposure Limit</div>
            <div style={valueRow}>{exposureLimit}</div>

            <div style={labelRow}>Password</div>
            <div style={{ ...valueRow, justifyContent: "flex-start", gap: "16px" }}>
              <span>*********</span>
              <span
                onClick={() => setShowChangePassword(true)}
                style={{ display: "inline-flex", alignItems: "center", gap: "6px", color: "#212529", cursor: "pointer", fontSize: "14px", fontFamily: "Tahoma, Helvetica, sans-serif" }}
              >
                Edit <FaRegEdit />
              </span>
            </div>
            <div style={{ background: "#fff", height: "14px" }} />
          </div>
        </div>
      </PageShell>
      <ChangePasswordModal open={showChangePassword} onClose={() => setShowChangePassword(false)} />
    </AccountLayout>
  );
};

export default MyProfileNew;
